import { render, staticRenderFns } from "./VerifyInvitation.vue?vue&type=template&id=c995b7f4&"
import script from "./VerifyInvitation.vue?vue&type=script&lang=ts&"
export * from "./VerifyInvitation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports